export const createMapByProperty = <T extends Record<string, any>>(data: T[], key: keyof T = 'id') => {
  const idMap = {} as Record<string, T>;
  data.forEach((item) => (idMap[item[key]] = item));

  return idMap;
};

export default createMapByProperty;
